import { combineReducers } from 'redux';

import MessagingInternalTypes from './types';

export const messagingInternalReducer = combineReducers({
  getMessages: MessagingInternalTypes.getMessages.getReducer(),
  getChats: MessagingInternalTypes.getChats.getReducer(),
  getMessagesChat: MessagingInternalTypes.getMessagesChat.getReducer(),
  sendMessageChat: MessagingInternalTypes.sendMessageChat.getReducer(),
  listProducts: MessagingInternalTypes.listProducts.getReducer(),
  getAffiliates: MessagingInternalTypes.getAffiliates.getReducer(),
  sendMessageBroadcast: MessagingInternalTypes.sendMessageBroadcast.getReducer(),
});
